function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _Object$assign;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { InternalButton } from "../../internal";
import { allowedBadgeSymbols } from "../../utils/badge";
import { allowedTooltipSymbols } from "../../utils/tooltip";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * A button is used to trigger an action or event, such as submitting a form, opening a dialog, canceling an action, or performing a delete operation.
 * It comes with multiple variants and intents, and are ideal for calling attention to where a user needs to do something in order to move forward in a flow.
 *
 * ## Accessibility ♿
 * - Accessibility features:
 *   - Visible focus state for keyboard users
 *   - Space activates the button
 *   - Automatic inverted contrast when transparent and outlined buttons are placed on Cards with a gradient background
 */
export var Button = /*#__PURE__*/React.forwardRef(function Button(_ref, ref) {
  var ariaControls = _ref['aria-controls'],
    ariaDescribedby = _ref['aria-describedby'],
    ariaExpanded = _ref['aria-expanded'],
    ariaHasPopup = _ref['aria-haspopup'],
    ariaLabel = _ref['aria-label'],
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$emphasis = _ref.emphasis,
    emphasis = _ref$emphasis === void 0 ? 'contained' : _ref$emphasis,
    form = _ref.form,
    hideAbove = _ref.hideAbove,
    hideBelow = _ref.hideBelow,
    id = _ref.id,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'secondary' : _ref$intent,
    leadIcon = _ref.leadIcon,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    m = _ref.m,
    mb = _ref.mb,
    ml = _ref.ml,
    mr = _ref.mr,
    mt = _ref.mt,
    mx = _ref.mx,
    my = _ref.my,
    onBlur = _ref.onBlur,
    _onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onPointerDown = _ref.onPointerDown,
    onPointerLeave = _ref.onPointerLeave,
    onPointerMove = _ref.onPointerMove,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    trailIcon = _ref.trailIcon,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    variant = _ref.variant,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'hug' : _ref$width,
    gradient = _ref.gradient;
  return _jsx(InternalButton, {
    "aria-controls": ariaControls,
    "aria-describedby": ariaDescribedby,
    "aria-expanded": ariaExpanded,
    "aria-haspopup": ariaHasPopup
    // To prevent consumers from using `aria-label` like a poor man's testid,
    // let's not allow passing `aria-label` when there's text for now until there's
    // a use-case
    ,
    "aria-label": children ? undefined : ariaLabel,
    disabled: disabled,
    emphasis: emphasis,
    form: form,
    hideAbove: hideAbove,
    hideBelow: hideBelow,
    id: id,
    intent: gradient ? undefined : intent,
    leadIcon: leadIcon,
    loading: loading,
    m: m,
    mb: mb,
    ml: ml,
    mr: mr,
    mt: mt,
    mx: mx,
    my: my,
    onBlur: onBlur
    // Don't pass onClick directly so we don't expose the event object to consumers at run-time
    ,
    onClick: function onClick() {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    },
    onFocus: onFocus,
    onPointerDown: onPointerDown,
    onPointerLeave: onPointerLeave,
    onPointerMove: onPointerMove,
    ref: ref,
    size: size,
    trailIcon: trailIcon,
    type: type,
    variant: variant,
    width: width,
    gradient: gradient,
    children: children
  });
});
Object.assign(Button, (_Object$assign = {}, _defineProperty(_Object$assign, allowedBadgeSymbols.Button, true), _defineProperty(_Object$assign, allowedTooltipSymbols.Button, true), _Object$assign));